'use client'

import { useState } from 'react'

import { Button, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@ui/web/components'
import { typographyVariants } from '@ui/web/lib'
import cn from '@config/tailwind/cn'

import type { HomeConnectRequestDetail } from './request-summary'
import { OptionRow } from './option-row'
import { HomeConnectRequestSummary } from './request-summary'

export type ConfirmChoice = 'existing' | 'new'

interface ConfirmStepProps {
  detail: HomeConnectRequestDetail
  onContinue: (choice: ConfirmChoice) => void
  onReject: () => void
  onClose: () => void
}

/** The first thing the parent sees: who is asking, and whether this child is already theirs. */
export function ConfirmStep({ detail, onContinue, onReject, onClose }: ConfirmStepProps) {
  const [choice, setChoice] = useState<ConfirmChoice>('existing')

  return (
    <>
      <DialogHeader>
        <DialogTitle>Permohonan Sambung Sekolah-Rumah</DialogTitle>
        <DialogDescription>
          Guru ini ingin berbagi informasi tentang kemajuan belajar siswanya denganmu.
        </DialogDescription>
      </DialogHeader>

      <HomeConnectRequestSummary detail={detail} />

      <p className={cn(typographyVariants({ variant: 'label-md' }), 'srd:text-neutral-black')}>
        Apakah ini salah satu anakmu yang sudah terdaftar?
      </p>

      <div role='radiogroup' aria-label='Jawaban permohonan' className='srd:flex srd:flex-col srd:gap-y-1'>
        <OptionRow selected={choice === 'existing'} onSelect={() => setChoice('existing')}>
          Ya, hubungkan ke anak yang sudah ada
        </OptionRow>
        <OptionRow selected={choice === 'new'} onSelect={() => setChoice('new')}>
          Bukan, buat akun anak baru
        </OptionRow>
      </div>

      <DialogFooter className='srd:flex-col srd:gap-y-2'>
        <Button className='srd:w-full' onClick={() => onContinue(choice)}>
          Lanjutkan
        </Button>
        <Button variant='outline' className='srd:w-full' onClick={onReject}>
          Tolak permohonan
        </Button>
        <Button variant='ghost' className='srd:w-full' onClick={onClose}>
          Kembali
        </Button>
      </DialogFooter>
    </>
  )
}
